import Checkboxes from 'components/Formik/Checkboxes';
import Parse from 'react-html-parser';

const TimbaSurvey = ({ initialValues, data }) => {
	initialValues.TIMBASURVEYS__Survey__pc = [];

	const { label, options } = data;

	return (
		<>
			{Parse(label)}
			<Checkboxes
				options={options}
				label='TIMBASURVEYS__Survey__pc'
				name='TIMBASURVEYS__Survey__pc'
			/>
		</>
	);
};

export default TimbaSurvey;
